var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mobile-app-cta',{attrs:{"title":_vm.$t('title'),"desktop-title":_vm.$t('desktopTitle'),"illustration-path":"images/dashboard/scan-contact.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }